import { AssociationsList, Card, Typography } from 'components';

type Props = {
  metricName: string;
  associations: Parameters<typeof AssociationsList>[0]['associations'];
};

export default function AssociationsCard({ metricName, associations }: Props) {
  if (!associations?.length) return null;

  return (
    <Card>
      <Typography variant={'heading-m'} className='mb-2'>
        Condition associations
      </Typography>
      <Typography variant='body-xs' className='mb-2'>
        {metricName} is associated with:
      </Typography>
      <AssociationsList associations={associations} />
    </Card>
  );
}
